export default __webpack_public_path__ + "static/Selah-c668082de800579542321c7f6eb10606.webp";